<template>
  <span class="inline-flex px-2 py-1 text-xs font-semibold rounded-full" :class="statusClass(value)">
    {{ statusLabel(value) }}
  </span>
</template>

<script>
export default {
  name: 'StatusPill',
  props: {
    value: { type: String, required: true }
  },
  setup() {
    const statusClass = (status) => (
      status === 'paid' ? 'bg-green-100 text-green-800' :
      status === 'pending' ? 'bg-yellow-100 text-yellow-800' :
      status === 'open' ? 'bg-orange-100 text-orange-800' :
      status === 'expired' ? 'bg-gray-100 text-gray-800' :
      status === 'failed' ? 'bg-red-100 text-red-800' :
      status === 'refunded' ? 'bg-blue-100 text-blue-800' :
      status === 'cancelled' ? 'bg-red-100 text-red-800' :
      'bg-gray-100 text-gray-800'
    )

    const statusLabel = (status) => (
      status === 'paid' ? 'Bezahlt' :
      status === 'pending' ? 'Ausstehend' :
      status === 'open' ? 'Offen' :
      status === 'expired' ? 'Abgelaufen' :
      status === 'failed' ? 'Fehlgeschlagen' :
      status === 'refunded' ? 'Erstattet' :
      status === 'cancelled' ? 'Storniert' :
      'Unbekannt'
    )

    return { statusClass, statusLabel }
  }
}
</script>

